import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/ui';

import { useBlueprintFormStore } from '@/components/blueprint-form/BlueprintForm';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/ui';
import { ImageFile } from './image-file';
import { ImageFPSR } from './image-fpsr';
import { ImageURL } from './image-url';

type ImageType = 'file' | 'url' | 'fpsr';

export const Image = () => {
  const imageType = useBlueprintFormStore(state => state.imageType);
  const setImageType = useBlueprintFormStore(state => state.setImageType);
  const setIsFpsrTagged = useBlueprintFormStore(
    state => state.setIsFpsrTagged
  );
  const setFpsrPath = useBlueprintFormStore(state => state.setFpsrPath);

  return (
    <FormField
      name="image_file"
      render={() => (
        <FormItem>
          <FormLabel>Screenshot</FormLabel>
          <FormControl>
            <Tabs
              value={imageType}
              onValueChange={value => {
                const next = value as ImageType;
                setImageType(next);
                if (next !== 'fpsr') {
                  setIsFpsrTagged(false);
                  setFpsrPath(null);
                }
              }}
            >
              <TabsList className="mb-2 h-12 rounded-lg bg-steel-800 p-1">
                <TabsTrigger className="flex-1 rounded-md" value="fpsr">
                  Render for me
                </TabsTrigger>
                <TabsTrigger className="flex-1 rounded-md" value="file">
                  Image file
                </TabsTrigger>
                <TabsTrigger className="flex-1 rounded-md" value="url">
                  Image URL
                </TabsTrigger>
              </TabsList>
              <TabsContent value="fpsr">
                <ImageFPSR />
              </TabsContent>
              <TabsContent value="file">
                <ImageFile />
              </TabsContent>
              <TabsContent value="url">
                <ImageURL />
              </TabsContent>
            </Tabs>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
